module.exports = "<div class=\"container\">\n    <div class=\"intro\">\n        <h2>Services Assigment</h2>\n        <p>Open console (F5) to see more</p>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12 col-md-8 col-md-offset-2\">\n            <app-active-users [users]=\"activeUsers\"></app-active-users>\n            <app-inactive-users [users]=\"inactiveUsers\"></app-inactive-users>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services-assigment/services-assigment.component.html
// module id = ./src/app/components/services-assigment/services-assigment.component.html
// module chunks = main